import React, {FC} from 'react';

import {VacationResponderModel} from '../../../models/api/vacationResponderModel';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';
import {SettingsSearchDropdownGenericItem} from './settingsSearchDropdownGenericItem';

/*
 * Props.
 */

interface SettingsSearchDropdownResponderItemProps extends SettingsSearchDropdownItemBaseProps {
  responder: VacationResponderModel;
  responderDescription: string;
}

/*
 * Component.
 */

export const SettingsSearchDropdownResponderItem: FC<SettingsSearchDropdownResponderItemProps> = (props) => {
  const {onSelect, responder, responderDescription} = props;

  return (
    <SettingsSearchDropdownGenericItem
      label={responder.name}
      onSelect={onSelect}
      iconName="palmtreeFilledSmall"
      title={responder.name}
      subtitle={responderDescription}
    />
  );
};
